import { useEffect, useState } from 'react';
import { RoleService } from '../../services/role/roleService';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage roles fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de roles.
----------------------------------------------------------------------------------------*/

const useRoles = (initialFilters = {}) => {

    const { userCan } = usePrivilege();
    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState<any>({
        limit: 999999,
        filter_filters: { ...initialFilters }
    });
    const fetchRoles = async (companyId?: string) => {
        if (!userCan('list', 'roles')) return;
        if (!userCan('list', 'companies') && filters.filter_filters?.companyId == undefined || filters.filter_filters?.companyId == null || filters.filter_filters?.companyId == '') return;
        try {
            const service = new RoleService();
            const response = await service.listSelectRoles(filters);
            const fetchedData = response.getResponseData().data;

            if (fetchedData && fetchedData?.data) {
                let mappedData;
                mappedData = fetchedData.data?.map((data: { id: string; name: string; companyName: string; }) => ({
                    value: data.id ,
                    label: userCan('list', 'companies') && data.companyName ? `${data.name} (${data.companyName})` : data.name,
                    
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching roles:', error);
        }
    };

    useEffect(() => {
        fetchRoles();
    }, [filters]);

    const getRolesList = () => {
        return data;
    };
    
    const updateRolesHookFilters = (newFilters: any) => {
        setFilters((prevFilters : any) => ({ ...prevFilters, ...newFilters }));
    };

    return { fetchRoles, getRolesList, updateRolesHookFilters };
}

export default useRoles;